import { Price } from '@models/ValueObject/Price'

export function formatPrice(price: Price): string {
  return `${formatInt(price.amount)} ${price.sign}`
}

export function formatInt(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export function formatFloat(x: any): string {
  if (x < 11) {
    x = parseFloat(x.toFixed(2))
  } else if (x < 90) {
    x = parseFloat(x.toFixed(1))
  } else {
    x = parseFloat(x.toFixed(0))
  }

  let parts = x.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  if (parts.length == 1) {
    return parts[0]
  }

  return parts.join('.')
}

export function formatFloatPretty(x: any) {
  x = formatFloat(x)
  let parts = x.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  if (parts.length == 1) {
    return <span>{parts[0]}</span>
  }

  return (
    <>
      <span>{parts[0]}.</span>
      <span className="text-[90%] font-light">{parts[0]}</span>
    </>
  )
}

export function thinSpace(): string {
  return ' '
}

export function formatRatingInt(rating: number): string {
  return Number((rating / 10).toFixed(1)) + ''
}

// /**
//  * Plural forms for russian words
//  * @param  {Number} count quantity for word
//  * @param  {Array} words Array of words. Example: ['депутат', 'депутата', 'депутатов'], ['комментарий', 'комментария', 'комментариев']
//  * @return {String}        Count + plural form for word
//  */
// export function pluralize(count: number, words: string[]): string {
//
//     let cases = [2, 0, 1, 1, 1, 2];
//     return words[ (count % 100 > 4 && count % 100 < 20) ? 2 : cases[ Math.min(count % 10, 5)] ];
// }

/**
 * @param {Array<String>} forms
 * @param {Number} n
 * @returns {String}
 */
export function pluralize(n: number, forms: string[]): string {
  let idx: number
  // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
  if (n % 10 === 1 && n % 100 !== 11) {
    idx = 0 // one
  } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    idx = 1 // few
  } else {
    idx = 2 // many
  }
  return forms[idx] || ''
}
